/**
 * Challenge winner announcement – posted when a challenge ends (e.g. to feed).
 */
export function createChallengeWinnerAnnouncement({
  id,
  challengeId,
  challengeTitle = '',
  submissionId,
  winnerUserId = '',
  winnerDisplayName = '',
  winnerAvatarUrl = '',
  videoUrl = '',
  voteCount = 0,
  announcedAt = null,
}) {
  return {
    id,
    challengeId,
    challengeTitle: challengeTitle || '',
    submissionId,
    winnerUserId: winnerUserId || '',
    winnerDisplayName: winnerDisplayName || '',
    winnerAvatarUrl: winnerAvatarUrl || '',
    videoUrl: videoUrl || '',
    voteCount: Number(voteCount) || 0,
    announcedAt: announcedAt?.toDate?.() ?? announcedAt ?? null,
  };
}
